import { CONST } from "../../CONST";

const CONFIG = {
    anchor: {x: 425, y: 800},
    origin: {x: 1, y: 0.33},
    texture: CONST.BURGER.HAND,
    depth: 50,
    angleOffset: -90,
}

export default class Hand {
    private scene: Phaser.Scene;

    private hand: Phaser.GameObjects.Image;

    private follow = true;

    constructor(scene: Phaser.Scene){
        this.scene = scene;

        this.hand = scene.add.image(420, 216, CONFIG.texture)
            .setDepth(CONFIG.depth)
            .setOrigin(CONFIG.origin.x, CONFIG.origin.y);
        
        this.scene.events.on('update', this.update, this);
    }

    update(){
        this.updateHandPosition();
    }

    updateHandPosition(){
        if (!this.follow) return;

        this.hand.x = this.scene.input.activePointer.x;
        this.hand.y = this.scene.input.activePointer.y;

       var angle = Phaser.Math.RadToDeg(Math.atan2((CONFIG.anchor.x-this.hand.x), (CONFIG.anchor.y-this.hand.y)));
       this.hand.setAngle(CONFIG.angleOffset-angle);
    }

    setFollow(follow: boolean){
        this.follow = follow;
    }
}